export default __webpack_public_path__ + "4f712f17699ad78028280a6ffd0ce325.ttf";